function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.654 9.4c-.46-.46-1.563-1.15-2.107-1.41-.63-.303-.862-.296-1.309.026-.372.268-.612.518-1.04.425-.429-.091-1.272-.732-2.091-1.547-.819-.819-1.456-1.663-1.547-2.09-.09-.432.16-.67.425-1.042.322-.446.331-.678.025-1.309C4.75 1.906 4.063.806 3.6.347c-.459-.46-.562-.36-.815-.269 0 0-.375.15-.747.397-.46.306-.716.563-.897.947-.178.384-.384 1.1.666 2.969.847 1.509 1.678 2.653 2.912 3.884l.003.003.004.003C5.96 9.516 7.1 10.347 8.61 11.194c1.869 1.05 2.584.843 2.969.665.384-.178.64-.434.947-.896.246-.372.396-.747.396-.747.091-.253.194-.357-.268-.816z"
});

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13"
  }, props), _ref);
}

export default SvgPhone;